import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Home from "./pages/HomePage";
import PricingPage from "./pages/PricingPage";
import MainServicePage from "./pages/MainServicePage";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
// import ProtectedRoute from './components/ProtectedRoute';
import LoginDialog from './dialogs/LoginDialog';
import { AuthProvider } from './context/AuthContext';
import TermsPage from './pages/TermsPage';

export default function App() {
  const [loginOpen, setLoginOpen] = useState(false);

  // const openLoginDialog = () => setLoginOpen(true);
  const closeLoginDialog = () => setLoginOpen(false);

  return (
    <AuthProvider>
      <Router>
        <Navbar />
        <Routes>
          {/* <Route path="/home" element={<Home />} /> */}
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/" element={<MainServicePage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
        <Footer />
        <LoginDialog open={loginOpen} onClose={closeLoginDialog} />
      </Router>
    </AuthProvider>
  );
}
